import React, { useState, useEffect } from "react";
import { onAuthStateChanged } from "firebase/auth";
import { auth } from "../../firebaseConfig";
import AddOfferServices from "./AddOfferServices";
import OfferMaker from "./OfferMaker";
import OfferDashboard from "./OfferDashboard";
import MicroservicesCreator from "./MicroservicesCreator/index";
import TeamSettings from "./TeamSettings";
import "./OfferCreator.css";

// Main component OfferCreator
const OfferCreator = () => {
  const [userId, setUserId] = useState(null);
  const [activeTab, setActiveTab] = useState("dashboard"); // "dashboard", "services", "microservices", "team" or "offers"
  const [isLoading, setIsLoading] = useState(true);
  const [newOfferData, setNewOfferData] = useState(null);
  const [isEditMode, setIsEditMode] = useState(false);

  // Auth monitoring
  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      if (user) {
        setUserId(user.uid);
      } else {
        setUserId(null);
      }
      setIsLoading(false);
    });

    return () => unsubscribe();
  }, []);

  // Create new offer and open for editing
  const handleCreateOffer = () => {
    // Set default offer data
    const defaultOfferData = {
      title: "New Offer",
      description: "",
      services: [],
      notes: "",
      logo: "",
      createdAt: Date.now(),
    };
    
    // Save offer data and switch to offers tab
    setNewOfferData(defaultOfferData);
    setIsEditMode(false);
    setActiveTab("offers");
  };

  // Edit existing offer
  const handleEditOffer = (offerData) => {
    setNewOfferData(offerData);
    setIsEditMode(true);
    setActiveTab("offers");
  };

  // Display for non-logged-in users
  if (!userId && !isLoading) {
    return <p className="offer-creator__error">Please log in to manage your offers.</p>;
  }

  return (
    <div className="offer-creator">
      {isLoading ? (
        <div className="offer-creator__loading">
          <div className="offer-creator__spinner"></div>
          <p>Loading...</p>
        </div>
      ) : (
        <>
          <div className="offer-creator__tabs">
            <button 
              className={`offer-creator__tab ${activeTab === "dashboard" ? "active" : ""}`}
              onClick={() => setActiveTab("dashboard")}
            >
              <div className="offer-creator__tab-icon">
                <img src="/img/dashboard.svg" alt="Dashboard" />
              </div>
              Offer Dashboard 
            </button>
            <button 
              className={`offer-creator__tab ${activeTab === "services" ? "active" : ""}`}
              onClick={() => setActiveTab("services")}
            >
              <div className="offer-creator__tab-icon">
                <img src="/img/service.svg" alt="Services" />
              </div>
              Services
            </button>
            <button 
              className={`offer-creator__tab ${activeTab === "microservices" ? "active" : ""}`}
              onClick={() => setActiveTab("microservices")}
            >
              <div className="offer-creator__tab-icon">
                <img src="/img/micro.svg" alt="Microservices" />
              </div>
              Microservices
            </button>
            <button 
              className={`offer-creator__tab ${activeTab === "team" ? "active" : ""}`}
              onClick={() => setActiveTab("team")}
            >
              <div className="offer-creator__tab-icon">
                <img src="/img/team.svg" alt="Team" />
              </div>
              Members
            </button>
          </div>
          
          <div className="offer-creator__content">
            {activeTab === "dashboard" && (
              <OfferDashboard 
                userId={userId} 
                onCreateOffer={handleCreateOffer}
                onEditOffer={handleEditOffer}
              />
            )}
            {activeTab === "services" && <AddOfferServices userId={userId} />}
            {activeTab === "microservices" && <MicroservicesCreator userId={userId} />}
            {activeTab === "team" && <TeamSettings userId={userId} />}
            {activeTab === "offers" && (
              <OfferMaker 
                userId={userId} 
                initialOfferData={newOfferData}
                isEditMode={isEditMode}
                onOfferSaved={() => {
                  setNewOfferData(null);
                  setIsEditMode(false);
                  setActiveTab("dashboard");
                }}
              />
            )}
          </div>
        </>
      )}
    </div>
  );
};

export default OfferCreator; 